import { Injectable } from "@angular/core";
import { GruposFiltrosServiceBackend } from "@serviceBackends";
import { GrupoDTO, GrupoFiltroDTO } from "@DTOS";

@Injectable({
    providedIn: "root"
})
export class GruposFiltrosService {
    private filtros: GrupoFiltroDTO[];

    constructor(private gruposFiltrosServiceBackend: GruposFiltrosServiceBackend) {}

    public async getGrupoFiltro(grupo: GrupoDTO): Promise<GrupoFiltroDTO> {
        // TODO: mejorar esto a un endpoint directo para obtener el grupofiltro
        await this.cargarGrupoFiltro();

        const grupoFiltroBase = new GrupoFiltroDTO({
            max_users: 0,
            include_active_users: false,
            enabled: true
        });

        const grupoFiltroArray = this.filtros.filter(grupoFiltro => grupoFiltro.grupo.id === grupo.id);

        return grupoFiltroArray.length === 0 ? grupoFiltroBase : grupoFiltroArray[0];
    }

    public async agregarGrupoFiltro(grupo: GrupoFiltroDTO): Promise<GrupoFiltroDTO> {
        const grupoFiltro = await this.gruposFiltrosServiceBackend.postGruposFiltros(grupo);
        await this.cargarGrupoFiltro();

        this.filtros.push(grupoFiltro);

        return grupoFiltro;
    }

    public async guardarGrupoFiltro(grupo: GrupoFiltroDTO): Promise<GrupoFiltroDTO> {
        const grupoFiltro = await this.gruposFiltrosServiceBackend.putGruposFiltros(grupo);
        await this.cargarGrupoFiltro();

        this.filtros = this.filtros.map(filtro => {
            if (filtro.id === grupoFiltro.id) {
                return grupoFiltro;
            }

            return filtro;
        });

        return grupoFiltro;
    }

    public async eliminarGrupoFiltro(grupo: GrupoFiltroDTO): Promise<void> {
        await this.gruposFiltrosServiceBackend.deleteGruposFiltros(grupo);
        await this.cargarGrupoFiltro();

        this.filtros = this.filtros.filter(filtro => filtro.id !== grupo.id);
    }

    public async cargarGrupoFiltro() {
        if (this.filtros == null) {
            this.filtros = await this.gruposFiltrosServiceBackend.getGruposFiltros();
        }
    }
}
